module.exports = __webpack_public_path__ + "img/bitcoin.f115c297.svg";